export default __webpack_public_path__ + "static/media/05.8e2a188d.jpg";